import React from 'react'
import SignIn from '../components/Signin'

const Signin = () => {
  return (
    <>
      <SignIn />
    </>
  )
}

export default Signin
